import { useEffect } from 'react';
import { RootState, useSelector } from 'redux/store';

const UnsavedChangesPrompt = () => {
  const { hasUnsavedChanges } = useSelector((state: RootState) => state.editing);

  useEffect(() => {
    if (!hasUnsavedChanges) {
      return;
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
    };

    globalThis.addEventListener('beforeunload', handleBeforeUnload);
    return () => globalThis.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  return null;
};

export default UnsavedChangesPrompt;
